module.exports = __webpack_public_path__ + "static/media/used9.cc93cadf.JPG";